import CircleCancel from '../src/CircleCancel';
export default CircleCancel;
